// Long-form articles used to rank for 'how much does a fence cost' type searches.
// Content kept in this file (mock data) so we can easily edit copy without touching code.

export const POSTS = [
  {
    slug: 'how-much-does-a-wood-fence-cost-shreveport-2026',
    title: 'How Much Does a Wood Fence Cost in Shreveport in 2026?',
    excerpt: 'A straight-talk breakdown of what wood privacy fencing costs in Shreveport-Bossier City in 2026, why the price varies, and how to get the most fence for your money.',
    date: '2026-01-15',
    readMinutes: 8,
    hero: '/gallery/06-cedar-with-trailer.jpg',
    tags: ['Wood', 'Cost', 'Shreveport'],
    keywords: 'wood fence cost Shreveport, cedar fence price Bossier City, how much for a fence Louisiana',
    body: [
      {h:'The short answer'},
      {p:'In Shreveport and Bossier City, a standard 6-foot wood privacy fence typically runs $18 to $32 per linear foot installed in 2026. A 150-foot backyard project usually lands between $2,700 and $4,800.'},
      {p:'That said, price depends heavily on the wood species, post type, gate count, and site prep. Below we break down every cost driver so you know exactly what you’re paying for.'},

      {h:'What drives the price'},
      {p:'Fence pricing comes down to five big variables: material, height, hardware, site conditions, and gate/access count.'},
      {p:'1. Material. Pressure-treated Southern Yellow Pine is the budget standard at $18–$22/ft installed. Premium Western Red Cedar runs $26–$32/ft and lasts 5–10 years longer. Cypress and redwood are more expensive still but rare in this region.'},
      {p:'2. Height. Standard is 6 ft. Going to 8 ft (common in urban lots or for extra pool privacy) adds roughly 25% because posts, rails, and pickets all get longer.'},
      {p:'3. Hardware. Hot-dipped galvanized nails and screws cost more than electro-galvanized but hold up much better in humid Louisiana weather. Stainless is another step up.'},
      {p:'4. Site conditions. Sloped yards, tree roots, existing fence removal, red clay soil, and rock all add labor cost. A flat mowed backyard is fastest and cheapest.'},
      {p:'5. Gates. Each 4-ft man-gate adds $250–$450. A 12-ft double drive gate adds $700–$1,400 depending on hardware.'},

      {h:'Cedar vs pine — what actually lasts'},
      {p:'Pressure-treated pine will last 12–18 years in Louisiana weather if properly sealed every 2–3 years. Cedar naturally resists rot and insects and lasts 20–30+ years with minimal maintenance. If you plan to stay in your home more than 8–10 years, cedar almost always pencils out cheaper long-term.'},

      {h:'Board-on-board vs standard privacy'},
      {p:'Standard side-by-side picket privacy fences leave small gaps over time as wood dries. Board-on-board (overlapping pickets) gives you true privacy forever plus a much nicer look for about $2–$4 more per linear foot.'},

      {h:'The hidden cost most contractors don’t mention'},
      {p:'Post depth. Cheap installers set 6-ft fences on 1.5–2 ft posts and skip the concrete. In Louisiana red clay with our wind gusts, those fences lean or fail within 3–5 years. Better Fence & Deck sets every post 3 ft deep in concrete, always. That single detail is why your fence lasts twice as long.'},

      {h:'Free estimates in Shreveport-Bossier'},
      {p:'Every wood-fence quote we hand you is on-site, in writing, and includes an itemized material list so you can compare apples to apples with any other contractor. Call 318-344-7190 or request a quote online — we usually respond within an hour during business hours.'},
    ],
  },
  {
    slug: 'vinyl-vs-wood-fencing-louisiana',
    title: 'Vinyl vs. Wood Fencing in Louisiana — Which One Wins?',
    excerpt: 'Both wood and vinyl have real pros and cons in northwest Louisiana’s hot, humid climate. Here’s the honest tradeoff so you can pick the right one for your yard.',
    date: '2026-02-02',
    readMinutes: 6,
    hero: '/gallery/19-vinyl-picket.jpg',
    tags: ['Vinyl', 'Wood', 'Guide'],
    keywords: 'vinyl vs wood fence Louisiana, best fence type Shreveport',
    body: [
      {h:'The upfront cost'},
      {p:'Wood wins on day one. A 6-ft cedar privacy fence runs $26–$32/ft installed; comparable vinyl privacy runs $32–$48/ft. On a 150-ft project that’s roughly a $1,200–$2,400 difference.'},
      {h:'The long-term cost'},
      {p:'Vinyl wins here. Vinyl needs a rinse with a garden hose once a year and that’s it. Wood needs cleaning + sealing every 2–3 years ($200–$500 each time) and eventually plank replacement.'},
      {h:'The look'},
      {p:'Wood has natural warmth and grain that most homeowners prefer aesthetically. Vinyl is clean, uniform, and stays looking brand-new for decades but can look plastic-y up close. Faux-wood-grain vinyl is a nice middle ground.'},
      {h:'The Louisiana climate factor'},
      {p:'Our humidity, UV, and pop-up storms are brutal on both. Wood swells, cracks, and molds if not sealed. Vinyl handles humidity great but low-quality vinyl gets brittle from UV over 15+ years. Only buy commercial-grade vinyl from established manufacturers — the cheap online stuff is not worth it.'},
      {h:'Our recommendation'},
      {p:'For most Shreveport homeowners: cedar wood if you love wood’s look and don’t mind sealing every couple of years, vinyl if you want to install once and forget about it. Both are great; the wrong choice is cheap pine with unsealed posts.'},
    ],
  },
  {
    slug: 'how-long-does-fence-installation-take',
    title: 'How Long Does Fence Installation Take? A Realistic Timeline',
    excerpt: 'From the first phone call to the last picket, here’s a realistic timeline for a residential fence install in Shreveport-Bossier.',
    date: '2026-02-18',
    readMinutes: 5,
    hero: '/gallery/13-wood-iron-gate-inprogress.jpg',
    tags: ['Timeline', 'Process'],
    keywords: 'fence installation timeline, how long to install a fence',
    body: [
      {h:'Step 1: Estimate (1–3 days)'},
      {p:'You call or fill out our quote form. We schedule an on-site walk-through within 24–72 hours, measure the yard, discuss layout and materials, and hand you a written quote before we leave.'},
      {h:'Step 2: Deposit & scheduling (1 day)'},
      {p:'Once you approve the quote, we take a small deposit to lock in materials, and put you on the calendar. During peak spring, this can be 2–4 weeks out. Winter is fastest.'},
      {h:'Step 3: Utility locate (3–5 business days)'},
      {p:'We call 811 (state one-call service) to have underground utilities marked before any post hole goes in. This is free and required by Louisiana state law.'},
      {h:'Step 4: Installation (2–5 days)'},
      {p:'Most 150–250 ft residential wood fences are complete in 2–4 days. Day 1: post-hole day. Day 2: concrete cures, we set stringers/rails. Day 3–4: pickets and gates. Larger jobs, ornamental iron, or deck builds run 5–10 days.'},
      {h:'Step 5: Walk-through & warranty (30 minutes)'},
      {p:'We walk the finished project with you, adjust any gate, hand you the written warranty, and clean the site. Payment is due at completion.'},
    ],
  },
  {
    slug: 'do-i-need-a-permit-for-a-fence-in-shreveport',
    title: 'Do I Need a Permit for a Fence in Shreveport?',
    excerpt: 'A quick guide to fence permits and HOA rules in Shreveport, Bossier City, and surrounding areas.',
    date: '2026-03-05',
    readMinutes: 4,
    hero: '/gallery/10-wood-brick-house.jpg',
    tags: ['Permits', 'HOA'],
    keywords: 'fence permit Shreveport, HOA fence rules Bossier',
    body: [
      {h:'The short answer'},
      {p:'In most Shreveport and Bossier City residential neighborhoods you do NOT need a city permit for a residential fence under 6 ft. Fences over 6 ft, front-yard fences, or commercial installs may require one.'},
      {h:'When you DO need something'},
      {p:'Above 6 ft tall (usually need a variance), front-yard fences (height restrictions apply, usually 4 ft), commercial or industrial lots, and any lot in a historic district. Rural parishes have their own rules.'},
      {h:'HOA approval'},
      {p:'If your neighborhood has a homeowners’ association — which most newer subdivisions do — you almost always need HOA approval before installing. We provide a scaled layout, material specs, and elevation drawings for HOA submission at no extra charge.'},
      {h:'How we help'},
      {p:'We’ve navigated permits and HOAs across the ArkLaTex for years. Tell us your neighborhood at estimate time and we’ll tell you exactly what paperwork you need and prep it with you.'},
    ],
  },
  {
    slug: 'best-fence-for-dogs-louisiana',
    title: 'The Best Fence for Dogs in Louisiana',
    excerpt: 'Choosing a dog-friendly fence in humid, muddy Louisiana takes more than picking a style. Here’s what actually works for dog owners in Shreveport.',
    date: '2026-03-20',
    readMinutes: 5,
    hero: '/gallery/16-chainlink-kiddie-pool.jpg',
    tags: ['Dogs', 'Guide'],
    keywords: 'best fence for dogs Louisiana, dog fence Shreveport',
    body: [
      {h:'Start with your dog’s escape method'},
      {p:'Jumpers, diggers, climbers, and chewers each need different solutions. Height stops jumpers; buried concrete or chicken-wire skirts stop diggers; smooth vinyl or wood stops climbers; chain-link stops chewers.'},
      {h:'Height guidance'},
      {p:'Small breeds: 4 ft is enough. Medium (labs, boxers): 5–6 ft. Large athletic breeds (huskies, malinois, pit mixes): 6–8 ft and often with an inward lean at the top.'},
      {h:'Best all-around option'},
      {p:'6-ft board-on-board cedar. No gaps to see through (dogs bark less when they can’t see the neighbor’s yard), no toeholds, and it looks great. Add a 12-inch buried concrete grade beam if you’ve got a digger.'},
      {h:'Budget option'},
      {p:'6-ft galvanized chain-link with a top rail. Cheapest per foot, escape-proof for most dogs, but see-through so it can trigger barking.'},
      {h:'Skip'},
      {p:'Invisible / electric fences. In Louisiana thunderstorm season the ground currents can shock dogs randomly, some dogs blow through the shock chasing prey, and it doesn’t keep other animals OUT.'},
    ],
  },
];

export const POST_BY_SLUG = Object.fromEntries(POSTS.map(p => [p.slug, p]));
